import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Toaster } from '../ui/sonner';
import { TesterModeBanner } from '../course/TesterModeBanner';

export function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex flex-col min-h-screen bg-background">
      <TesterModeBanner />
      <div className="flex flex-1">
        <Sidebar 
          isOpen={sidebarOpen} 
          onToggle={() => setSidebarOpen(!sidebarOpen)} 
        />
        <main className="flex-1 min-h-screen flex flex-col">
          <div className="p-4 md:p-8 lg:p-12 pt-20 md:pt-8 flex-1">
            {children}
          </div>
          <footer className="border-t border-stone-200 bg-white/60 px-4 md:px-8 lg:px-12 py-6 mt-8" data-testid="site-footer">
            <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-text-muted">
              <p>© {new Date().getFullYear()} Bellarine Tech Assist · Digital Safety Course</p>
              <nav className="flex items-center gap-4 flex-wrap justify-center">
                <Link to="/terms" data-testid="footer-terms" className="hover:text-primary hover:underline">Terms of Service</Link>
                <span className="text-stone-300">·</span>
                <Link to="/privacy" data-testid="footer-privacy" className="hover:text-primary hover:underline">Privacy Policy</Link>
                <span className="text-stone-300">·</span>
                <Link to="/refund" data-testid="footer-refund" className="hover:text-primary hover:underline">Refund Policy</Link>
              </nav>
            </div>
          </footer>
        </main>
      </div>
      <Toaster position="bottom-right" />
    </div>
  );
}
